import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { BaseService } from './baseService';
import { AppConstants } from '../../utils/appConstants.class';
import { Inspection, InspectionClipboard } from '../models';

@Injectable({
  providedIn: 'root'
})
export class InspectionClipboardService extends BaseService {
  public applicationTypes: any[];

  constructor() {
    super();
  }

  private getStorageName(inspection: Inspection) {
    return `${AppConstants.MODULES_CLIPBOARD}_${this.currentUserId}_${inspection.applicationType}_${
      inspection.applicationSubType ?? ''
    }`;
  }

  public getData(inspection: Inspection): InspectionClipboard {
    return JSON.parse(localStorage.getItem(this.getStorageName(inspection)));
  }

  public setData(data: InspectionClipboard, inspection: Inspection) {
    return localStorage.setItem(this.getStorageName(inspection), JSON.stringify(data));
  }

  public clearData(inspection: Inspection) {
    return localStorage.removeItem(this.getStorageName(inspection));
  }

  public hasData(inspection: Inspection) {
    const clipboard: InspectionClipboard = JSON.parse(localStorage.getItem(this.getStorageName(inspection)));
    return clipboard && clipboard.selectedItems && clipboard.selectedItems.length > 0;
  }

  public canProcess(inspection: Inspection) {
    if (inspection.isOffline && !this.isInspectionInOffline(inspection.id)) {
      return false;
    }
    return true;
  }
}
